import React from "react";
import { cn } from "../../lib/utils";

interface LayoutProps {
  children: React.ReactNode;
  className?: string;
}

export function Layout({ children, className }: LayoutProps) {
  return (
    <main className={cn("flex-grow w-full py-20 px-4 sm:px-6 md:px-12 lg:px-24", className)}>
      {children}
    </main>
  );
}